import * as React from "react";
const SvgFiRrFireplace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fireplace_svg__a)">
      <path
        fill="#062147"
        d="M12.292 14.85a.472.472 0 0 0-.719.108c-.846 1.431-.652 3.481-1.41 3.481-.359 0-.303-.62-.472-1.004a.396.396 0 0 0-.67-.082c-.717.884-1.405 2.443-.77 3.965.677 1.629 2.208 2.779 3.97 2.676a4.02 4.02 0 0 0 3.78-4.01c0-2.112-2.343-3.915-3.709-5.134m.866 7.592a1.545 1.545 0 0 1-2.35 0c-.537-.625-.433-1.58.15-2.162l.681-.682c.19-.19.497-.19.687 0l.682.682c.582.582.686 1.538.15 2.162M23 22V5.238l.842-1.674.077-.207a2.69 2.69 0 0 0-.492-2.318A2.69 2.69 0 0 0 21.298 0H2.702C1.865 0 1.088.379.573 1.039a2.68 2.68 0 0 0-.49 2.318L1 5.222V22a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1v-8.6c0-1.246.772-2.373 1.923-2.803 2.112-.792 4.042-.792 6.154 0A3 3 0 0 1 17 14.4V23a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2M2.15 2.27A.69.69 0 0 1 2.701 2h18.596a.69.69 0 0 1 .553.27c.07.091.175.271.144.515L21.385 4H2.616l-.61-1.215a.7.7 0 0 1 .143-.515m13.63 7.454c-2.564-.96-4.996-.96-7.56 0C6.294 10.446 5 12.325 5 14.4V22H3V6h18v16h-2v-7.6c0-2.075-1.295-3.954-3.222-4.676z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fireplace_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFireplace;
